<template>
  <div class="product-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div>
            <h1 class="pl-card__title">لیست محصولات</h1>
            <p class="pl-card__sub">مدیریت، ویرایش و موجودی کالاها</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="goAddNews()">
            <CIcon name="iconPlus"/>
            <span>افزودن محصول</span>
          </button>
          <button type="button" class="pl-btn pl-btn--ghost" @click="download_product_excel()">
            <CIcon name="iconDownload"/>
            <span>دانلود اکسل</span>
          </button>
          <button type="button" class="pl-btn pl-btn--ghost" @click="open_products_json_modal()">
            <CIcon name="iconList"/>
            <span>نمایش JSON</span>
          </button>
          <button type="button" class="pl-btn pl-btn--ghost" @click="download_products_json()">
            <CIcon name="iconDownload"/>
            <span>دانلود JSON</span>
          </button>
          <button type="button" class="pl-btn pl-btn--ghost" @click="open_file_selector()">
            <CIcon name="iconUpload"/>
            <span>آپلود اکسل</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CTabs class="pl-tabs">
          <CTab v-for="filter in filters" :key="'ft-' + filter.value" :title="filter.label">

            <div class="pl-bulk" v-if="checkbox_ids.length>0">
              <CRow>
                <CCol col="12" sm="3">
                  <CSelect
                    :options="bulk_edit_items"
                    :value.sync="selected_bulk_edit"
                  />
                </CCol>
                <CCol col="12" sm="4" v-if="selected_bulk_edit=='add_to_category'">
                  <div class="control_wrapper">
                    <treeselect
                        v-model="value_category"
                        :multiple="false"
                        :flat="true"
                        :normalizer="normalizer_category"
                        :options="options_category"
                        placeholder="دسته بندی محصول را انتخاب کنید"
                    />
                  </div>
                </CCol>
                <CCol col="12" sm="3">
                  <CInputCurrency
                      placeholder="مقدار"
                      v-model="bulk_edit_value"
                  />
                </CCol>
                <CCol col="12" sm="2">
                  <CButton color="primary" class="pl-bulk__apply" @click="bulk_edit()">
                    اعمال تغییرات
                  </CButton>
                </CCol>
              </CRow>
            </div>

            <CDataTableFixed
                class="pl-table"
                :items="items.filter(x=>x.status==filter.value)"
                :fields="fields"
                column-filter
                :checkbox="true"
                :checkbox_ids.sync="checkbox_ids"
                checkbox_key="id"
                :items-per-page="20"
                hover
                sorter
                pagination
                :loading="paging[filter.value].loading"
                :has-more="paging[filter.value].has_more"
                :load-error="paging[filter.value].error"
                @load-more="load_page(filter.value)"
                :noItemsView="{ noItems: 'محصولی یافت نشد' }"
            >
              <template #no-items-view>
                <div class="pl-empty">
                  <span class="pl-empty__icon" aria-hidden="true">
                    <CIcon name="navProducts"/>
                  </span>
                  <p class="pl-empty__title">محصولی یافت نشد</p>
                  <p class="pl-empty__sub">برای شروع، یک محصول جدید اضافه کنید یا فیلترها را تغییر دهید.</p>
                </div>
              </template>

              <template #row="{item,index}">
                <td>
                  <span class="pl-muted">{{ index + 1 }}</span>
                </td>
              </template>

              <template #code="{item}">
                <td>
                  <span class="pl-code">{{ item.code }}</span>
                </td>
              </template>

              <template #is_featured="{item}">
                <td>
                  <button
                    type="button"
                    class="pl-star"
                    :class="{ 'is-on': item.is_featured != 0 }"
                    :title="item.is_featured == 0 ? 'ویژه کردن' : 'حذف از ویژه'"
                    @click="item.is_featured==0 ? (update_featured_item(item,1), item.is_featured=1) : (update_featured_item(item,0), item.is_featured=0)"
                  >
                    <CIcon v-if="item.is_featured==0" name="iconStar"/>
                    <CIcon v-else name="iconStarFill"/>
                  </button>
                </td>
              </template>

              <template #type="{item}">
                <td>
                  <span class="pl-muted" v-if="item.type==1">فیزیکی</span>
                  <span class="pl-muted" v-if="item.type==2">دانلودی</span>
                  <span class="pl-muted" v-if="item.type==3">ویدئویی</span>
                </td>
              </template>

              <template #price="{item}">
                <td>
                  <div class="pl-price" v-if="item.prices.length==1">
                    <div class="pl-price__row">
                      <CInputCurrency class="pb-0" v-model="item.prices[0].price"/>
                      <button type="button" class="pl-icon-btn pl-icon-btn--success" title="ذخیره قیمت" @click="update_product_price(item)">
                        <CIcon name="iconCheck"/>
                      </button>
                    </div>
                    <div class="pl-price__off">
                      <span class="pl-price__off-label">بعد از تخفیف</span>
                      <CInputCurrency class="pb-0" v-model="item.prices[0].off_price"/>
                    </div>
                  </div>
                </td>
              </template>

              <template #stock="{item}">
                <td>
                  <div class="pl-stock" v-if="item.prices.length==1">
                    <CInputCurrency class="pb-0" v-model="item.prices[0].stock"/>
                    <button type="button" class="pl-icon-btn pl-icon-btn--success" title="ذخیره موجودی" @click="update_product_stock(item)">
                      <CIcon name="iconCheck"/>
                    </button>
                  </div>
                </td>
              </template>

              <template #image="{item}">
                <td>
                  <div class="pl-thumb" v-if="item.gallery.length>0">
                    <CImg width="44px" height="44px" v-bind:src="item.gallery[0].image"/>
                  </div>
                </td>
              </template>

              <template #operation="{item,index}">
                <td class="pl-ops-cell">
                  <div class="pl-ops">
                    <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش" @click="editDetails(item,index)">
                      <CIcon name="iconEdit"/>
                    </button>
                    <button type="button" class="pl-icon-btn pl-icon-btn--info" title="کپی" @click="editDetailsClone(item,index)">
                      <CIcon name="iconClone"/>
                    </button>
                    <button type="button" class="pl-icon-btn pl-icon-btn--danger" title="حذف" @click="delete_item_dialog(item)">
                      <CIcon name="iconTrash"/>
                    </button>
                    <button
                      type="button"
                      class="pl-icon-btn"
                      :class="item.status==1 ? 'pl-icon-btn--danger' : 'pl-icon-btn--success'"
                      :title="item.status==1 ? 'غیرفعال کردن' : 'فعال کردن'"
                      @click="deactive_product(item)"
                    >
                      <CIcon v-if="item.status==1" name="iconEyeOff"/>
                      <CIcon v-else name="navEye"/>
                    </button>
                    <button type="button" class="pl-icon-btn pl-icon-btn--teal" title="قیمت ترکیبی" @click="go_bundle_price(item)">
                      <CIcon name="iconDollar"/>
                    </button>
                    <button type="button" class="pl-icon-btn pl-icon-btn--teal" title="ویژگی‌ها" @click="go_additional_values(item)">
                      <CIcon name="iconList"/>
                    </button>
                    <button type="button" class="pl-icon-btn pl-icon-btn--info" title="دیدگاه‌ها" @click="go_comments(item)">
                      <CIcon name="iconComment"/>
                    </button>
                    <button type="button" class="pl-btn pl-btn--sm pl-btn--ghost" @click="go_show_product(item)">
                      <CIcon name="navEye"/>
                      <span>نمایش</span>
                    </button>
                  </div>
                </td>
              </template>
            </CDataTableFixed>
          </CTab>
        </CTabs>
      </div>
    </div>

    <CModal
        title="لیست محصولات (JSON)"
        size="xl"
        :show.sync="json_modal"
    >
      <div class="pl-json">
        <div class="pl-json__meta">
          <span v-if="json_loading">در حال دریافت محصولات...</span>
          <span v-else>تعداد محصولات: {{ json_count }}</span>
        </div>
        <textarea class="pl-json__box" dir="ltr" readonly :value="json_text"></textarea>
      </div>
      <template #footer>
        <CButton color="primary" @click="copy_products_json()">کپی JSON</CButton>
        <CButton color="info" @click="download_products_json()">دانلود فایل JSON</CButton>
        <CButton color="dark" @click="json_modal = false">بستن</CButton>
      </template>
    </CModal>
    <CInputFile
        custom
        horizontal
        id="excel_uploader_file"
        v-show="false"
        v-on:change="handleFileUpload"
    />
  </div>
</template>

<script>
import axios from "@/api/http";
import {bus} from "../../main";
import xlsx from "json-as-xlsx";
import readXlsxFile from 'read-excel-file'
import Treeselect from "@riophae/vue-treeselect";


export default {
  name: 'Login',
  components: {
    Treeselect
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      bulk_edit_items:[
        {label:'انتخاب کنید',value:''},
        {label:'افزایش قیمت (مبلغ)',value:'increase_price'},
        {label:'افزایش قیمت (درصد)',value:'increase_percent'},
        {label:'کاهش قیمت (مبلغ)',value:'decrease_price'},
        {label:'کاهش قیمت (درصد)',value:'decrease_percent'},
        {label:'اعمال تخفیف (مبلغ)',value:'off_price'},
        {label:'اعمال تخفیف (درصد)',value:'off_percent'},
        {label:'افزودن به دسته بندی',value:'add_to_category'},
        {label:'حذف انتخابی ها',value:'delete_selected'},
      ],
      selected_bulk_edit:'',
      bulk_edit_value:'',
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      checkbox_ids:[],
      name: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      excel_file: null,
      items: [],
      paging: { 1: { page: 0, has_more: true, loading: false, error: false, seq: 0 }, 2: { page: 0, has_more: true, loading: false, error: false, seq: 0 } },
      json_modal: false,
      json_text: '',
      json_count: 0,
      json_loading: false,
      fields: [
        {key: 'row', label: '#', _style: 'width:3%', sorter: false, filter: false},
        {key: 'image', label: 'تصویر', _style: 'width:7%'},
        {key: 'name', label: 'عنوان', _style: 'width:25%'},
        {key: 'code', label: 'کد', _style: 'width:7%'},
        // {key: 'type', label: 'نوع', _style: 'width:7%;'},
        {key: 'price', label: "قیمت", _style: 'width:13%;'},
        {key: 'stock', label: "موجودی", _style: 'width:7%;'},
        {key: 'is_featured', label: "★", _style: 'width:5%;'},
        {key: 'operation', label: 'عملیات', _style: 'width:12%;'},

      ],
      filters: [
        {label: 'محصولات فعال', value: 1},
        {label: 'محصولات غیر فعال', value: 2},
      ],
      details: [],
      collapseDuration: 0,
      options_category: [],
      value_category: null,

      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      status_form: 0
    }
  },
  mounted() {
    this.get_categories();

    this.get_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function (id) {
      this.get_data();
    },

  },
  methods: {
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_category = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    // ---- JSON export of the product list (same API as the table) ----
    fetch_products_for_json() {
      const formData = new FormData();
      let url = '/api/admin/product/get_products';
      if (this.$route.params.cat_id) {
        url = '/api/admin/product/get_products_by_cat';
        formData.append('cat_id', this.$route.params.cat_id);
      }
      return axios.post(url, formData, {}).then((response) => {
        const content_data = response.data || {};
        if (content_data.error) {
          throw new Error(content_data.message || 'API error');
        }
        const items = content_data.items || [];
        return items.map((val) => ({
          id: val.id,
          name: val.title && val.title.title !== undefined ? val.title.title : val.name,
          code: val.code,
          status: val.status,
          status_label: val.status == 1 ? 'فعال' : 'غیرفعال',
          type: val.type,
          is_featured: val.is_featured,
          prices: (val.prices || []).map((p) => ({
            id: p.id,
            price: p.price,
            off_price: p.off_price,
            stock: p.stock,
          })),
          images: (val.gallery || []).map((g) => g.image),
        }));
      });
    },
    open_products_json_modal() {
      this.json_modal = true;
      this.json_loading = true;
      this.json_text = '';
      this.fetch_products_for_json().then((pros) => {
        this.json_count = pros.length;
        this.json_text = JSON.stringify(pros, null, 2);
      }).catch((error) => {
        console.log(error);
        this.json_text = '// خطا در دریافت محصولات: ' + (error && error.message ? error.message : error);
      }).finally(() => {
        this.json_loading = false;
      });
    },
    download_products_json() {
      const save = (text) => {
        const blob = new Blob([text], {type: 'application/json;charset=utf-8'});
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        const d = new Date();
        const stamp = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        link.download = 'products-' + stamp + '.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
      };
      if (this.json_text && !this.json_loading && this.json_text.charAt(0) === '[') {
        save(this.json_text);
        return;
      }
      this.fetch_products_for_json().then((pros) => {
        save(JSON.stringify(pros, null, 2));
      }).catch((error) => {
        console.log(error);
        alert('خطا در دریافت محصولات');
      });
    },
    copy_products_json() {
      if (!this.json_text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.json_text);
      } else {
        const ta = document.createElement('textarea');
        ta.value = this.json_text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    },
    download_product_excel() {
      var self = this;
      const formData = new FormData();
      var url = '/api/admin/product/get_products';
      if (this.$route.params.cat_id) {
        url = '/api/admin/product/get_products_by_cat'
        formData.append("cat_id", this.$route.params.cat_id)
      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.error == false) {

          var pros = []
          content_data.items.forEach(function (val,index) {

            pros.push({
              id:val.id,
              name:val.title.title,
              code:val.code,
              price:val.prices[0].price,
              off_price:val.prices[0].off_price,
              stock:val.prices[0].stock,
            })
          })
          const fileName = "Products"
          let settings = {
            fileName: fileName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: true, // Display the columns from right-to-left (the default value is false)
          }
          let data_json = [
            {
              sheet: "Sheet1",
              columns: [
                { label: "id", value: "id" }, // Top level data
                { label: "name", value: "name" }, // Top level data
                { label: "code", value: "code" }, // Top level data
                { label: "price", value: "price" }, // Top level data
                { label: "off_price", value: "off_price" }, // Top level data
                { label: "stock", value: "stock" }, // Top level data
              ],
              content: pros,
            },
          ]

          xlsx(data_json, settings)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    editDetails(item, index) {
      this.$router.push({path: "/dashboard/products/edit/" + item.id});

    },
    editDetailsClone(item, index) {
      this.$router.push({path: "/dashboard/products/clone/" + item.id});

    },
    go_bundle_price(item, index) {
      this.$router.push({path: "/dashboard/products/bundle_price/" + item.id});
    },
    go_additional_values(item, index) {
      this.$router.push({path: "/dashboard/products/additional-relation/" + item.id});
    },
    go_comments(item, index) {
      this.$router.push({path: "/dashboard/products/comments/" + item.id});
    },
    go_show_product(item) {
      window.open(localStorage.getItem("web_address") + "product/" + item.title.slug, "_blank");
    },
    upload_excel_items(items) {
      var url = '/api/admin/product/update_product_excel';
      var self = this

      var formData = new FormData();
      formData.append("items", JSON.stringify(items))
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);
        self.get_data()

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    bulk_edit() {
      var url = '/api/admin/product/bulk_edit_products';
      var self = this

      var formData = new FormData();
      formData.append("op", this.selected_bulk_edit)
      formData.append("value", this.bulk_edit_value)
      formData.append("ids", this.checkbox_ids)
      formData.append("category", this.value_category)
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);
        self.get_data()

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_product_price(item) {
      var url = '/api/admin/product/update_product_price';
      var self = this

      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("price", item.prices[0].price.replace(/,/g, ''))
      formData.append("off_price", item.prices[0].off_price.replace(/,/g, ''))
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_product_stock(item) {
      var url = '/api/admin/product/update_product_stock';
      var self = this
      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("stock", item.prices[0].stock.replace(/,/g, ''))
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_featured_item(item, status) {
      var url = '/api/admin/product/update_product_featured';
      var self = this
      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("status", status)
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    // server paging: 20 rows per request per status tab, next page loaded when the table's sentinel is reached
    get_data() {
      this.items = []
      ;[1, 2].forEach((s) => {
        const st = this.paging[s]
        Object.assign(st, { page: 0, has_more: true, loading: false, error: false, seq: st.seq + 1 })
        this.load_page(s)
      })
    },
    load_page(status) {
      const st = this.paging[status]
      if (st.loading || !st.has_more) return
      st.loading = true
      st.error = false
      const seq = st.seq
      const formData = new FormData()
      let url = '/api/admin/product/get_products'
      if (this.$route.params.cat_id) {
        url = '/api/admin/product/get_products_by_cat'
        formData.append('cat_id', this.$route.params.cat_id)
      }
      formData.append('status', status)
      formData.append('page', st.page + 1)
      formData.append('per_page', 20)
      axios.post(url, formData, { show_pros: false }).then((response) => {
        if (seq !== st.seq) return
        const d = response.data || {}
        if (d.error) throw new Error(d.msg || 'error')
        const rows = (d.items || []).map((val) => { val.name = val.title.title; return val })
        const seen = new Set(this.items.map((x) => x.id))
        this.items = this.items.concat(rows.filter((x) => !seen.has(x.id)))
        st.page = d.page || st.page + 1
        st.has_more = st.page < (d.last_page || 1)
      }).catch((error) => {
        if (seq === st.seq) st.error = true
        console.log(error)
      }).finally(() => {
        if (seq === st.seq) st.loading = false
      })
    },

    goAddNews() {

      this.$router.push({path: '/dashboard/products/create'});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_product";


      formData.append('post_id', this.status_form);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    deactive_product(item) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/deactive_product";
      if (item.status == 2) {
        url = "/api/admin/product/active_product";
      }

      formData.append('post_id', item.id);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    handleFileUpload(files, e) {
      console.log("handle upload")
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }

      // e.target.value = '';
      // e.target.files = '';
      this.excel_file = myfile

      this.read_ecel()
      // e.target = null

    },
    read_ecel() {
      var self= this
      try {
        if (this.excel_file) {
          readXlsxFile(this.excel_file).then((rows) => {
            // `rows` is an array of rows
            var excel_fields = []
            var excel_items = []
            if (rows.length > 0) {
              for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                if (i == 0) {
                  row.forEach(function (val, index) {
                    excel_fields.push({label: val, key: val})
                  })
                } else {
                  var item = {};
                  row.forEach(function (val, index) {
                    item[rows[0][index]] = val
                  })
                  excel_items.push(item)
                }


              }

            }
            self.upload_excel_items(excel_items);
console.log("read excel",excel_items,excel_fields);
            // each row being an array of cells.
          }).catch((rows) => {
            console.log("invalid file 1")
            alert('Invalid File')
          })
        }

      } catch (e) {
        console.log("invalid file 2")

        alert('Invalid File');
      }

    },

    open_file_selector() {
      document.getElementById("excel_uploader_file").click()
    },
  }
}


</script>
<style scoped lang="scss">
/* Spacing scale: 8 / 12 / 16 / 20 / 24 — aligned with Dashboard / AddProduct */
.product-list-page {
  padding: 0 0 24px;
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pl-json__meta {
  font-size: 13px;
  color: var(--panel-muted, #8094ae);
  margin-bottom: 8px;
}

.pl-json__box {
  width: 100%;
  min-height: 420px;
  font-family: Consolas, Menlo, monospace;
  font-size: 12px;
  line-height: 1.5;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--panel-border, rgba(128,148,174,.2));
  background: var(--panel-surface-2, #f7f8fb);
  color: var(--panel-text, #364a63);
  text-align: left;
  white-space: pre;
  resize: vertical;
}

.pl-card {
  background: var(--panel-surface, #fff);
  border: 1px solid var(--panel-border, rgba(128,148,174,.14));
  border-radius: 16px;
  box-shadow: none;
  overflow: hidden;
}

.pl-card__header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--panel-border, rgba(128,148,174,.14));
}

.pl-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pl-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pl-card__icon .c-icon {
  width: 20px;
  height: 20px;
}

.pl-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--panel-text, #364a63);
  line-height: 1.3;
}

.pl-card__sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
}

.pl-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s ease, color .15s ease, border-color .15s ease, transform .12s ease;
  white-space: nowrap;
}

.pl-btn .c-icon {
  width: 16px;
  height: 16px;
}

.pl-btn:active {
  transform: scale(.98);
}

.pl-btn--primary {
  background: #111111 !important;
  color: #ffffff !important;
  border-color: #111111 !important;
}

.pl-btn--primary span,
.pl-btn--primary .c-icon,
.pl-btn--primary ::v-deep .c-icon,
.pl-btn--primary ::v-deep path {
  color: #ffffff !important;
  stroke: #ffffff !important;
  fill: none;
}

.pl-btn--primary:hover {
  background: #111111 !important;
  color: #ffffff !important;
}

.pl-btn--primary:hover span,
.pl-btn--primary:hover .c-icon {
  color: #ffffff !important;
}

.pl-btn--ghost {
  background: var(--panel-surface-2, #f7f8fb);
  color: var(--panel-text, #364a63);
  border-color: var(--panel-border, rgba(128,148,174,.2));
}

.pl-btn--ghost:hover {
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  border-color: var(--accent-ring, rgba(37, 99, 235, .25));
}

.pl-btn--sm {
  min-height: 30px;
  padding: 4px 10px;
  font-size: 12px;
}

.pl-card__body {
  padding: 12px 16px 16px;
}

.pl-bulk {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 12px;
  background: var(--panel-surface-2, #f7f8fb);
  border: 1px solid var(--panel-border, rgba(128,148,174,.12));
}

.pl-bulk__apply {
  width: 100%;
  border-radius: 10px;
}

.pl-muted {
  color: var(--panel-muted, #8094ae);
  font-size: 13px;
}

.pl-code {
  font-size: 12px;
  color: var(--panel-nav, #6e82a5);
  background: var(--panel-surface-2, #f7f8fb);
  padding: 3px 8px;
  border-radius: 8px;
  display: inline-block;
  border: 1px solid var(--panel-border, rgba(128,148,174,.12));
}

.pl-thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--panel-border, rgba(128,148,174,.14));
  background: var(--panel-surface-2, #f7f8fb);
  margin: 0 auto;
}

.pl-thumb ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pl-price {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 132px;
}

.pl-price__row,
.pl-stock {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 110px;
}

.pl-price__off {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  border-radius: 8px;
  background: var(--panel-surface-2, #f7f8fb);
  border: 1px solid var(--panel-border, rgba(128,148,174,.12));
}

.pl-price__off-label {
  font-size: 11px;
  color: var(--panel-muted, #8094ae);
  text-align: right;
}

.pl-star {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: var(--panel-surface-2, #f7f8fb);
  color: var(--panel-muted, #8094ae);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pl-star.is-on {
  color: #16a34a;
  background: rgba(22, 163, 74, 0.12);
}

.pl-star .c-icon {
  width: 16px;
  height: 16px;
}

.pl-ops-cell {
  vertical-align: middle !important;
}

.pl-ops {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  max-width: 240px;
}

.pl-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--panel-border, rgba(128,148,174,.2));
  background: var(--panel-surface, #fff);
  color: var(--panel-nav, #6e82a5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.pl-icon-btn .c-icon {
  width: 14px;
  height: 14px;
}

.pl-icon-btn:hover {
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  border-color: var(--accent-ring, rgba(37, 99, 235, .3));
}

.pl-icon-btn--warn { color: #d97706; border-color: rgba(217,119,6,.25); }
.pl-icon-btn--danger { color: #dc2626; border-color: rgba(220,38,38,.25); }
.pl-icon-btn--info { color: #2563eb; border-color: rgba(37,99,235,.25); }
.pl-icon-btn--teal { color: #0d9488; border-color: rgba(13,148,136,.25); }
.pl-icon-btn--success { color: #16a34a; border-color: rgba(22,163,74,.25); }

.pl-icon-btn--warn:hover { background: rgba(217,119,6,.1); color: #d97706; }
.pl-icon-btn--danger:hover { background: rgba(220,38,38,.1); color: #dc2626; }
.pl-icon-btn--info:hover { background: rgba(37,99,235,.1); color: #2563eb; }
.pl-icon-btn--teal:hover { background: rgba(13,148,136,.1); color: #0d9488; }
.pl-icon-btn--success:hover { background: rgba(22,163,74,.1); color: #16a34a; }

.pl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 40px 16px;
  text-align: center;
}

.pl-empty__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  margin-bottom: 4px;
}

.pl-empty__icon .c-icon {
  width: 22px;
  height: 22px;
}

.pl-empty__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--panel-text, #364a63);
}

.pl-empty__sub {
  margin: 0;
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
  max-width: 280px;
}

/* Segmented tabs — beat global _mono underline tabs */
.product-list-page ::v-deep .pl-tabs > .nav-tabs,
.product-list-page ::v-deep .nav-tabs {
  border: 0 !important;
  border-bottom: 0 !important;
  gap: 4px;
  background: var(--panel-surface-2, #f3f5f9);
  padding: 4px;
  border-radius: 10px;
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
}

.product-list-page ::v-deep .nav-tabs .nav-link {
  border: 0 !important;
  border-bottom: 0 !important;
  border-radius: 8px !important;
  color: var(--panel-nav, #6e82a5) !important;
  background: transparent !important;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 12px !important;
  margin: 0 !important;
}

.product-list-page ::v-deep .nav-tabs .nav-link.active {
  background: var(--panel-surface, #fff) !important;
  color: var(--panel-accent, var(--accent, #2563eb)) !important;
  border-bottom: 0 !important;
  box-shadow: none;
}

.product-list-page ::v-deep .tab-content {
  margin-top: 0;
  padding: 0;
}

/* Compact panel-table inside this page */
.product-list-page ::v-deep .panel-table-wrap {
  border-radius: 12px;
  border-color: var(--panel-border, rgba(128,148,174,.14));
}

.product-list-page ::v-deep .panel-table__head th {
  padding: 9px 8px !important;
  font-size: 12px;
  letter-spacing: 0;
}

.product-list-page ::v-deep .panel-table__filters th {
  padding: 6px 8px !important;
}

.product-list-page ::v-deep .panel-table__filters .form-control {
  min-height: 30px;
  height: 30px;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 8px;
}

.product-list-page ::v-deep .panel-table tbody td {
  padding: 9px 8px !important;
  font-size: 13px;
}

.product-list-page ::v-deep .panel-table .form-control {
  min-height: 30px;
  font-size: 12px;
  border-radius: 8px;
}

.product-list-page ::v-deep .panel-pagination {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
}

@media (min-width: 768px) {
  .pl-card__header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
  }

  .pl-card__body {
    padding: 12px 20px 20px;
  }

  .pl-card__title {
    font-size: 20px;
  }

  .pl-ops {
    max-width: 280px;
  }
}

@media (max-width: 575.98px) {
  .product-list-page {
    margin-left: -10px;
    margin-right: -10px;
  }

  .pl-card__header,
  .pl-card__body {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
